module.exports = __webpack_public_path__ + "static/media/linkEndFrame.da6c5f88.png";